import React from "react";
import { Box, Button, Chip, Container, Typography } from "@mui/material";
import { brandFilledButtonSx } from "../../utils/brandAssets";
import MarketingReveal from "./MarketingReveal";

const TONES = {
  black: {
    bgcolor: "#000000",
    borderColor: "rgba(255, 255, 255, 0.06)",
    chipBg: "rgba(132, 230, 229, 0.12)",
    chipColor: "#84E6E5",
  },
  paper: {
    bgcolor: "background.paper",
    borderColor: "divider",
    chipBg: "action.hover",
    chipColor: "text.secondary",
  },
};

const MarketingProductSection = ({
  tone = "paper",
  chip,
  title,
  body,
  ctaLabel,
  onCta,
  children,
}) => {
  const skin = TONES[tone] || TONES.paper;
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 7, md: 10 },
        bgcolor: skin.bgcolor,
        borderTop: 1,
        borderBottom: 1,
        borderColor: skin.borderColor,
      }}
    >
      <Container maxWidth="lg">
        <MarketingReveal>
          <Box textAlign="center" sx={{ mb: 4 }}>
            <Chip
              label={chip}
              size="small"
              sx={{
                mb: 2,
                bgcolor: skin.chipBg,
                color: skin.chipColor,
                fontWeight: 600,
              }}
            />
            <Typography
              variant="h3"
              component="h2"
              sx={{
                fontWeight: 700,
                mb: 2,
                fontSize: { xs: "1.85rem", md: "2.5rem" },
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="h6"
              color="text.secondary"
              sx={{ maxWidth: 560, mx: "auto", fontWeight: 400, lineHeight: 1.6 }}
            >
              {body}
            </Typography>
          </Box>
        </MarketingReveal>
        <MarketingReveal delay={90}>
          <Box sx={{ mb: 4 }}>{children}</Box>
        </MarketingReveal>
        {ctaLabel ? (
          <MarketingReveal delay={160}>
            <Box textAlign="center">
              <Button
                variant="contained"
                size="large"
                onClick={onCta}
                sx={{ ...brandFilledButtonSx, px: 4, py: 1.5, fontWeight: 700 }}
              >
                {ctaLabel}
              </Button>
            </Box>
          </MarketingReveal>
        ) : null}
      </Container>
    </Box>
  );
};

export default MarketingProductSection;
